const HIDDEN_FIELDS = ['disc_assessment', 'talent_label', 'disc', 'talentLabel'];

export function stripInternalFields(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map(stripInternalFields);
    const copy = { ...value };
    HIDDEN_FIELDS.forEach((field) => {
        delete copy[field];
    });
    if (copy.profile) copy.profile = stripInternalFields(copy.profile);
    return copy;
}

export function hasInternalField(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return HIDDEN_FIELDS.some((field) => Object.prototype.hasOwnProperty.call(obj, field));
}
